import { ApiClientFactory } from './ApiClientFactory';

let clientFactory = new ApiClientFactory();

export const ContentClient = {
    getUserContent() {
        return clientFactory.get('content/list');
    },

    getLibraryContent() {
        return clientFactory.get('content/library');
    },

    getPath(id) {
        return clientFactory.get('content/path?id='+id);
    },

    getContentItem(id, mission) {
        return clientFactory.get('content/item?id='+id+'&mission='+mission);
    },

    startContentItem(id, mission) {
        return clientFactory.get('content/item-started?id='+id+'&mission='+mission);
    },

    completeContentItem(id, mission) {
        return clientFactory.get('content/item-completed?id='+id+'&mission='+mission);
    },

    getQuestLink(id){
        return clientFactory.get('content/quest-link?id='+id);
    },

};

